import Immutable  from "immutable";

const initialState = {
    email: "",
    password: "",
	signing: false,
    error: "",
    sessionExpired: false
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case "SIGN_IN_UPDATE_EMAIL":
            return Immutable
                .fromJS(state)
                .set("email", action.value)
                .toJS();
        case "SIGN_IN_UPDATE_PASSWORD":
            return Immutable
                .fromJS(state)
                .set("password", action.value)
                .toJS();
        case "SIGN_IN_PENDING":
        case "SIGN_IN_BY_TOKEN_PENDING":
            return Immutable
                .fromJS(state)
                .set("signing", true)
                .set("error", "")
                .set("sessionExpired", false)
                .toJS();
        case "SIGN_IN_FULFILLED":
        case "SIGN_IN_BY_TOKEN_FULFILLED":
            return Immutable
                .fromJS(state)
                .set("signing", false)
                .set("email", "")
                .set("password", "")
                .toJS();
        case "SIGN_IN_REJECTED":		
        case "SIGN_IN_BY_TOKEN_REJECTED":
            return Immutable
                .fromJS(state)
                .set("signing", false)
                .set("error", action.payload.response.data.message)
				.toJS();
        case "SESSION_EXPIRED":
            return Immutable
                .fromJS(state)
                .set("sessionExpired", true)
                .toJS();
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/signIn.js